<template>
  <div>
    <table class="ts-w-full ts-mt-3">
      <thead>
        <tr class="ts-bg-gray-200 ts-border-b ts-border-t">
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-3">
            {{ $t('borrowingSparePart.no') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.borrowingNumber') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-40">
            {{ $t('borrowingSparePart.barcode') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-56">
            {{ $t('borrowingSparePart.product') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.uom') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.qtyOrder') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.qtyReturn') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.qtyLost') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-right ts-bg-gray-100
            ">
            {{ $t('borrowingSparePart.unitPrice') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase ts-bg-gray-100 ts-border-r ts-w-24
            ">
            {{ $t('borrowingSparePart.cusR') }}
          </th>
          <th class="
              ts-px-3
              ts-py-2
              ts-uppercase
              ts-bg-gray-100
              ts-border-r
              ts-w-24
              ts-text-center
            ">
            {{ $t('borrowingSparePart.cusR%') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase ts-bg-gray-100 ts-w-40 ts-text-right
            ">
            {{ $t('borrowingSparePart.amount') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-border-r ts-border-gray-200 ts-w-24 ts-whitespace-no-wrap
            ">
            {{ $t('borrowingSparePart.vendorRes') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-border-r ts-border-gray-200 ts-w-24
            ">
            {{ $t('borrowingSparePart.vendor%') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-w-32 ts-text-right ts-border-r ts-border-gray-200
            ">
            {{ $t('borrowingSparePart.stPrice') }}
          </th>
          <th class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-w-32 ts-text-right
            ">
            {{ $t('borrowingSparePart.amount') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="ts-border-b" v-for="(p, index) in model.product_detail" :key="index">
          <td class="ts-px-3 ts-py-2">{{ index + 1 }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.sfo_number }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.barcode }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.product_name }}</td>
          <td class="ts-px-3 ts-py-2">
            <select class="ts-w-full ts-outline-none" v-model="p.uom_id">
              <option v-for="(u, index) in getUomList(p.product_id)" :key="index" :value="u.uom_id">
                {{ u.uom_name_kh }}
              </option>
            </select>
          </td>
          <td class="ts-px-3 ts-py-2">
            <input :value="p.quantity_order" type="text" class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1"
              readonly />
          </td>
          <td class="ts-px-3 ts-py-2">
            <input v-model.number="p.quantity_return" type="number"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1" />
          </td>
          <td class="ts-px-3 ts-py-2">
            <input v-model.number="p.lost_qty" type="number"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1" />
          </td>
          <td class="ts-px-3 ts-py-2 ts-bg-gray-100">
            <ts-currency-input type="text" :value="p.sale_price * model.fx_rate_kh" currency="៛" class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
              " />
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center ts-bg-gray-100 ts-border-r">
            <input :checked="p.customer_cover" type="checkbox" :true-value="true" :false-value="false" />
          </td>
          <td class="ts-px-3 ts-py-2 ts-bg-gray-100 ts-border-r">
            <input :value="p.customer_percentage" type="text"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1" readonly />
          </td>
          <td class="ts-px-3 ts-py-2 ts-bg-gray-100 ts-border-r">
            <ts-currency-input currency="៛" type="text" :value="customerAmount(p)" class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
              " readonly />
          </td>
          <td class="
              ts-px-3 ts-py-2 ts-text-center
              vendor-part
              ts-border-r ts-border-gray-200
            ">
            <input v-model="p.is_vendor_cover" type="checkbox" :true-value="true" :false-value="false" />
          </td>
          <td class="ts-px-3 ts-py-2 vendor-part ts-border-r ts-border-gray-200">
            <input v-model="p.vendor_cover_percentage" type="number" class="
                ts-w-full ts-text-center ts-border ts-rounded ts-py-1
                vendor-color
              " readonly />
          </td>
          <td class="ts-px-3 ts-py-2 vendor-part ts-border-r ts-border-gray-200">
            <ts-currency-input currency="฿" type="text" :value="p.vendor_standard_price * 32" class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
                vendor-color
              " readonly />
          </td>
          <td class="ts-px-3 ts-py-2 vendor-part">
            <ts-currency-input type="text" currency="฿" :value="vendorRepAmount(p)" class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
                vendor-color
              " readonly />
          </td>
        </tr>
        <tr>
          <td colspan="5" class="ts-text-right ts-px-3 ts-py-2">
            <strong>{{ $t('borrowingSparePart.total') }} : </strong>
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center">
            {{ $formatNumber(quantityOrder) }}
          </td>
          <td class="ts-px-2 ts-py-2 ts-text-center ts-pr-6">
            {{ $formatNumber(quantityReturn) }}
          </td>
          <td class="ts-px-2 ts-py-2 ts-text-center ts-pr-6">
            {{ $formatNumber(quantityLost) }}
          </td>
          <td colspan="4" class="ts-px-5 ts-py-2 ts-text-right">
            {{ '៛ ' + $formatNumber(customerTotalAmount) }}
          </td>
          <td class="ts-px-5 ts-py-2 ts-text-right vendor-color" colspan="4">
            {{ '฿ ' + $formatNumber(vendorRepTotalAmount.toFixed(2)) }}
          </td>
        </tr>
        <tr>
          <td colspan="9" class="ts-text-right ts-px-3 ts-py-2">
            <strong>{{ $t('borrowingSparePart.discount') }} : </strong>
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center">
            <!-- <select class="ts-w-full ts-outline-none" v-model="model.discount_type">
              <option value="%">%</option>
              <option :value="getDiscountCurrency(model.input_currency_id)">
                {{ getDiscountCurrency(model.input_currency_id) }}
              </option>
            </select> -->
          </td>
          <td colspan="2" class="ts-px-5 ts-py-2 ts-text-right">
            {{ '៛ ' + $formatNumber(discountAmount) }}
          </td>
          <td colspan="2" class="ts-px-2 ts-py-2 ts-text-right ts-pr-6">
            <strong>{{ $t('borrowingSparePart.incentive') }} : </strong>
          </td>
          <td colspan="2" class="ts-px-5 ts-py-2 ts-text-right">
            {{ '฿ ' + $formatNumber(incentiveAmount) }}
          </td>
        </tr>
        <tr>
          <td colspan="9" class="ts-text-right ts-px-3 ts-py-2">
            <strong>{{ $t('borrowingSparePart.grandTotal') }} : </strong>
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center">
          </td>
          <td colspan="2" class="ts-px-5 ts-py-2 ts-text-right">
            {{ '៛ ' + $formatNumber(model.input_grand_total) }}
          </td>
          <td colspan="4"></td>
          <!-- <td colspan="2" class="ts-px-2 ts-py-2 ts-text-right ts-pr-6">
            <strong>{{ $t('borrowingSparePart.totalIncentive') }} : </strong>
          </td>
          <td colspan="2" class="ts-px-5 ts-py-2 ts-text-right">
            {{ '฿ ' + $formatNumber(incentiveAmount + vendorRepTotalAmount) }}
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { includes } from 'lodash'
import { sumBy } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: ['value'],
  data() {
    return {
      priceType: 2,
      customerTotalAmount: 0,
      vendorRepTotalAmount: 0,
      quantityOrder: 0,
      quantityReturn: 0,
      quantityLost: 0,
      model: {},
      tempDetails: [],
    }
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['formModels']),
    customerAmount: (vm) => (product) => {
      return (
        ((product.sale_price *
          (product.quantity_order - product.quantity_return - product.lost_qty) *
          product.customer_percentage) /
          100) *
        vm.model.fx_rate_kh
      )
    },
    vendorRepAmount: (vm) => (product) => {
      let price =
        product.vendor_standard_price *
        (product.quantity_order - product.quantity_return - product.lost_qty)

      return ((price * product.vendor_cover_percentage) / 100) * 32
    },
    getUomList: (vm) => (productId) => {
      let uomList = vm.tempDetails.find((d) => d.product_id == productId)
      return uomList ? uomList.unit_of_measures : []
    },
    discountAmount() {
      return this.model.discount_rate * this.model.fx_rate_kh
    },
    incentiveAmount() {
      return this.model.incentive_rate * this.model.fx_rate_thb
    },
  },
  created() {
    this.model = this.value
  },
  methods: {
    getDiscountCurrency(input_currency_id) {
      if (this.formModels['currency']) {
        return this.formModels['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol
      }
      return null
    },
    removeRow() { },
    sumQuantityOrder() {
      this.quantityOrder = 0
      this.model.product_detail.forEach((p) => {
        let quantity_order = p.quantity_order ? p.quantity_order : 0
        this.quantityOrder = this.quantityOrder + quantity_order
      })
    },
    sumQuantityReturn() {
      this.quantityReturn = 0
      this.model.product_detail.forEach((p) => {
        let quantity_return = p.quantity_return ? p.quantity_return : 0
        this.quantityReturn = this.quantityReturn + quantity_return
      })
    },
    sumQuantityLost() {
      this.quantityLost = 0
      this.model.product_detail.forEach((p) => {
        let quantity_lost = p.lost_qty ? p.lost_qty : 0
        this.quantityLost = this.quantityLost + quantity_lost
      })
    },
    sumCustomerAmount() {
      this.customerTotalAmount = 0
      this.model.product_detail.forEach((p) => {
        let CustomerAmount =
          ((p.sale_price *
            (p.quantity_order - p.quantity_return - p.lost_qty) *
            p.customer_percentage) /
            100) *
          this.model.fx_rate_kh

        this.customerTotalAmount = this.customerTotalAmount + CustomerAmount
      })
    },
    sumVendorRepAmount() {
      this.vendorRepTotalAmount = 0
      this.model.product_detail.forEach((p) => {
        let price =
          p.vendor_standard_price * (p.quantity_order - p.quantity_return - p.lost_qty)

        let VendorRepAmount = ((price * p.vendor_cover_percentage) / 100) * 32
        this.vendorRepTotalAmount = this.vendorRepTotalAmount + VendorRepAmount
      })
    },
    checkPromotion() {
      if (this.formModels.promotions) {
        let incentive_by_amount = this.formModels.promotions.incentive_by_amount.length > 0 ?
          this.formModels.promotions.incentive_by_amount
            .filter(el => {
              const total = sumBy(
                this.model.product_detail
                  .filter(d => includes(el.spare_part_group_id, d.pro_group_id))
                  .map(p => p.sale_price * (p.quantity_order - p.quantity_return - p.lost_qty))
              );

              switch (el.operator_sign) {
                case 'between':
                  return total > el.amount_from && total < el.amount_to && this.model.product_id == el.product_id;
                case '>=':
                  return total > el.amount_from && this.model.product_id == el.product_id;
                case '=':
                  return total === el.amount_from && this.model.product_id == el.product_id;
                default:
                  return false;
              }
            })
            .sort((a, b) => b.amount_from - a.amount_from)[0]
          : null

        if (incentive_by_amount) {
          this.model.vendor_customer_id = incentive_by_amount.vendor_customer_id
          this.model.incentive_product_id = incentive_by_amount.incentive_product_id
          this.model.currency_id = incentive_by_amount.currency_id
          this.model.input_currency_id = incentive_by_amount.input_currency_id
          this.model.discount_type = incentive_by_amount.discount_type
          this.model.discount_rate = incentive_by_amount.discount_rate
          this.model.input_discount_rate = incentive_by_amount.input_discount_rate
          this.model.incentive_type = incentive_by_amount.incentive_type
          this.model.incentive_rate = incentive_by_amount.incentive_rate
          this.model.input_incentive_rate = incentive_by_amount.input_incentive_rate
          this.model.grand_total = (this.customerTotalAmount / this.model.fx_rate_kh) - incentive_by_amount.discount_rate
          this.model.input_grand_total = (this.customerTotalAmount) - (incentive_by_amount.discount_rate * this.model.fx_rate_kh)
        } else {
          this.model.vendor_customer_id = null
          this.model.incentive_product_id = null
          this.model.discount_type = '%'
          this.model.discount_rate = 0
          this.model.input_discount_rate = 0
          this.model.incentive_type = '%'
          this.model.incentive_rate = 0
          this.model.input_incentive_rate = 0
          this.model.grand_total = this.customerTotalAmount / this.model.fx_rate_kh
          this.model.input_grand_total = this.customerTotalAmount
        }
      }
    },
  },
  watch: {
    'model.product_detail': {
      handler() {
        this.sumQuantityOrder()
        this.sumQuantityReturn()
        this.sumQuantityLost()
        this.sumVendorRepAmount()
        this.sumCustomerAmount()
        this.checkPromotion()
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.vendor-part {
  background: rgb(255, 255, 255);
}

.vendor-color {
  color: #fc4813;
  font-weight: 700;
}
</style>
